import type { LegalPageKey } from '@astrologermatch/shared';
import { SITE_NAME } from '../components/Layout.js';
import { LEGAL_DOCS } from '../legal/content.js';
import { useSeo } from '../lib/seo.js';
import { useSettings } from '../lib/state.js';

export function LegalPage({ page }: { page: LegalPageKey }) {
  const settings = useSettings();
  const doc = LEGAL_DOCS[page];
  useSeo({
    title: `${doc.title} | ${SITE_NAME}`,
    description: doc.description,
    canonical: `${settings.siteUrl}/${page}`,
  });
  return (
    <div className="wrap page-pad legal">
      <article className="card legal-card">
        <h1>{doc.title}</h1>
        <p className="lede-dark">{doc.intro}</p>
        {doc.sections.map((s) => (
          <section key={s.heading}>
            <h2 className="h3">{s.heading}</h2>
            {s.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
            {s.bullets && (
              <ul>
                {s.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </article>
    </div>
  );
}
